export const domUtils = {
  findFieldWrapper: (el) => {
    if (!el) return null;
    const selectors = [".form-field-wrapper", ".form-field", ".field", ".form__field-holder"];
    const element = el.length ? el[0] : el;
    return element.closest ? selectors.map((s) => element.closest(s)).find(Boolean) : null;
  },

  shouldValidateField: (field) => {
    const wrapper = domUtils.findFieldWrapper(field);
    if (wrapper && wrapper.offsetHeight === 0) return false;
    if (field.closest("fieldset[disabled]")) return false;
    if (field.getAttribute("aria-required") === "true") return true;
    if (field.getAttribute("data-required") === "true") return true;
    if (!field.name || field.disabled || field.readonly) return false;

    return true;
  },
};
